<template>
  <div>
    <div class="row meeting-outer-container meeting-extra">

      <!-- Normal meeting card -->
      <div class="col-md-12 meeting-item-col col-modified" :class="col_size">
        <div class="card card-modified" :style="maxheight" v-bind:style="left_style">
          <div class="card-body card-body-modified d-flex" style="min-height: 0;">

            <div style="overflow-y: scroll;">
              <div class="row row-custom col-12">
                <div class="col-12 row-custom">
                  <h1 id="meeting-title">{{ meeting_info.name }}</h1>
                </div>
                <div class="col-12 row-custom">
                  <h5 class="text-sub">{{ $t(meeting_info.meeting_type) }}</h5>
                </div>
              </div>
              <hr>
              <div class="row mb-5" >
                <ul style="list-style-type: none;">
                  <li v-for="(meeting, index) in meeting_items">
                    <h2 id="item-title">{{ index + 1 }}. {{ meeting.name }}</h2>
                    <p id="item-description" class="text-sub" v-if="meeting.description !== null">
                      {{ meeting.description }}
                    </p>
                    <a v-show="currentUser === meeting_facilitator.uid" @click="showModal(meeting.uid)"><i
                      class="ti-plus"></i> {{ $t("Add docs") }}</a>
                  </li>
                </ul>
                <hr>

              </div>
              <div class="buttons-bottom">
                <div class="bg-white">
                <hr>
                <button @click="startMeeting(true)" class="btn btn-rounded btn-outline-secondary preview-style">{{ $t("Preview meeting") }}</button>
                <button @click="startMeeting()"
                        v-show="meeting_facilitator.uid === currentUser && meeting_data.date_ended === null"
                        class="btn btn-rounded btn-info">{{ $t("Start meeting") }}
                </button>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- meeting info -->
      <div class="col-lg-6 col-md-12 col-info">
        <div id="info-card" class="card">
          <div class="card-body">
            <div class="m-b-10">
              <h2 class="card-title" v-show="meeting_data.date_started === null">{{ minutes_till | startTimeFilter }}</h2>
              <h2 class="card-title" v-show="meeting_data.date_ended !== null">{{ $t("This meeting has been completed at") }}
                {{ meeting_data.date_ended | formatDate }}</h2>
              <hr>
            </div>
            <div>
              <div class="row">
                <div class="col-lg-6 col-md-12">
                  <h5 class="font-bold">{{ $t('Type') }}</h5>
                  <p class="text-sub">{{ $t(meeting_info.meeting_type) }}</p>

                  <h5 class="font-bold">{{ $t('Time') }}</h5>
                  <p class="text-sub">{{ meeting_data.date_start_string }}</p>

                  <h5 class="font-bold">{{ $t('Invitees') }}</h5>
                  <p class="text-sub">{{ meeting_info.attendees }}</p>
                </div>

                <div class="col-lg-6 col-md-12">
                  <h5 class="font-bold">{{ $t('Duration') }}</h5>
                  <p class="text-sub">{{ Math.ceil((meeting_duration / 60)) }} {{ $t('minutes') }}</p>

                  <h5 class="font-bold">{{ $t('Location') }}</h5>
                  <p class="text-sub">{{ meeting_info.location }}</p>

                  <h5 class="font-bold">{{ $t('Facilitator') }}</h5>
                  <p class="text-sub">{{ meeting_facilitator.firstname }} {{ meeting_facilitator.lastname }}</p>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <h5 class="font-bold">{{ $t('Description') }}</h5>
                  <vue-markdown class="text-sub" v-if="meeting_data.description !== null" :source="meeting_data.description"></vue-markdown>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <add-documents-modal :meeting_items="meeting_items" :selected="from_item" v-show="showDocumentsModal" v-if="data_loaded"
                         @close="showDocumentsModal = false"></add-documents-modal>

  </div>
</template>

<script>
  import apiHelper from "../mixins/APIHelper";
  import AddDocumentsModal from "./AddDocumentsModal";

  export default {
    components: {
      "add-documents-modal": AddDocumentsModal
    },
    name: "meetingview",
    data: function () {
      return {
        meetingID: 0,
        currentTime: new moment(),
        meeting_data: [],
        meeting_items: [],
        meeting_info: [],
        meeting_attendees: [],
        meeting_facilitator: [],
        meeting_duration: 0,
        preview: true,
        currentUser: localStorage.getItem("user_uid"),
        showDocumentsModal: false,
        showNavbar: false,
        windowWidth: 0,
        windowHeight: 0,
        maxheight: 0,
        left_style: 0,
        hrwidth: 0,
        col_size: "col-lg-6",
        col_small: "col-6",
        data_loaded: false,
        itemIndex: 0
      }
    },
    created() {
      let vm = this;
      vm.getMeetingData();
    },
    mounted(){
      this.$nextTick(function () {
        window.addEventListener('resize', this.getWindowWidth);
        window.addEventListener('resize', this.getWindowHeight);

        //Init
        this.getWindowWidth();
        this.getWindowHeight();

        this.$parent.inMeeting = true;

      });
    },
    beforeDestroy() {
      this.$parent.title = "";
      this.$parent.inMeeting = false;
      window.removeEventListener('resize', this.getWindowWidth);
      window.removeEventListener('resize', this.getWindowHeight);
    },
    methods: {
      getWindowWidth(event) {
        this.windowWidth = document.documentElement.clientWidth;

        if (!(document.body.classList).contains("mini-sidebar") && this.windowWidth < 1400) {
          this.toggleSidebar();
        }
        //
        // if (this.windowWidth < 1250) {
        //   this.col_size = "col-lg-12";
        // } else {
        //   this.col_size = "col-lg-6";
        // }

        if (this.windowWidth < 1250 && this.windowWidth > 992) {
          this.col_small = "col-12";
        } else  if (this.windowWidth < 992 && this.windowWidth > 630) {
          this.col_small = "col-6";
        } else if (this.windowWidth < 630) {
          this.col_small = "col-12";
        } else {
          this.col_small = "col-6";
        }

      },

      getWindowHeight(event) {
        this.windowHeight = document.documentElement.clientHeight;
        let diff = this.$parent.getTopbar();
        let pagetitle = this.$parent.getPageTitles();
        let footer = this.$parent.getFooter();
        let style = "";

        if (this.windowWidth <= 992) {
          style = "min-height: " + (this.windowHeight - diff - footer) + "px;";
        } else {
          style = "height: " + (this.windowHeight - diff) + "px;";
        }

        this.maxheight = style;

        style = style + " margin-top: " + (-1 * (pagetitle + 20)) + "px;";
        style = style + " margin-bottom: " + (-1 * footer) + "px;";
        this.left_style = style;
      },

      toggleSidebar(){
        let vm = this;
        const body = document.body;
        if((body.classList).contains("mini-sidebar")) {
          body.classList.remove("mini-sidebar");
          vm.showNavBar = true;
        } else {
          body.classList.add("mini-sidebar");
          vm.showNavbar = false;
        }
      },

      // Grab the data for this meeting from the server and assign to correct variables
      getMeetingData() {
        let vm = this;
        vm.meetingID = this.$route.params.id;
        apiHelper.getResource("/api/meeting/" + vm.meetingID + "/view").then((data) => {
          if (data.status === 404 || !('meeting_id' in data) || data.status === 403) {
            vm.$notify({
              group: "notification",
              title: vm.$t("Error"),
              text: vm.$t("Something went wrong, please try again."),
              type: 'error'
            });
            vm.$router.push("/meetings");

            return;
          }

          vm.meeting_data = data;
          vm.meeting_items = data.MeetingItems;
          vm.meeting_info = data.MeetingNorm;
          vm.meeting_attendees = data.AttendeeList;
          vm.meeting_facilitator = data.Facilitator;

          this.$parent.$emit("addTitleBreadcrumb", vm.meeting_info.name);
          vm.getAttendees(vm.meeting_attendees);
          vm.parseMeetingTime();

          // If this is a live meeting, start immediately
          if (vm.meeting_data['date_started'] !== null && vm.meeting_data['date_ended'] === null) {
            vm.preview = false;
            vm.startMeeting();
          }

          vm.getWindowHeight();

          // Fix, necessary for mobile
          window.scrollTo(0,0);
        });
      },

      // Extracts all the names of the attendees and formats them nicely
      getAttendees(aData) {
        let vm = this;
        let attendees = ""; //vm.meeting_facilitator.firstname + " " + vm.meeting_facilitator.lastname;

        for (let i = 0; i < aData.length; i++) {
          attendees += aData[i].firstname + ' ' + aData[i].lastname;

          if (i < aData.length - 1) {
            attendees += ', ';
          }
        }

        vm.meeting_info.attendees = attendees;

      },

      // Start the meeting
      startMeeting(preview = false) {
        let vm = this;
        this.preview = preview;
        if (preview) {
          vm.$router.push("/meetingpreview/" + vm.meetingID);
        } else {
          vm.$router.push("/havemeeting/" + vm.meetingID);
        }
      },

      parseMeetingTime() {
        let vm = this;

        let startTime = moment(vm.meeting_data.date_start);
        let endTime = moment(vm.meeting_data.date_end);
        vm.meeting_duration = Math.floor((endTime - startTime) / 1000);
        vm.meeting_data.date_start_string = moment(startTime).format('ddd MMM Do, hh:mm');
      },

      showModal: function (value) {
        this.from_item = value;
        this.$emit("changeItem", value);
        this.data_loaded = true;
        this.showDocumentsModal = !this.showDocumentsModal;
      },
      beforeDestroy(){
        this.$parent.$emit("removeTitleBreadcrumb");
      }

    },
    computed: {
      minutes_till: function () {
        let vm = this;
        let startTime = moment(vm.meeting_data.date_start);
        return Math.floor((startTime - vm.currentTime) / 60000);
      }
    }
  }
</script>

<style scoped>
  .card-modified {
    margin-bottom: 0;
    border: none !important;
  }

  .card-body-modified {
    padding: 6.5rem 4rem 4rem 4rem;
  }

  .row-custom {
    justify-content: space-between;
    margin-left: 0;
    margin-right: 0;
    padding-left: 0;
  }

  .row-custom > div.col-6 {
    padding-left: 0;
  }

  .buttons-bottom {
    position: absolute;
    bottom: 6%;
    width: 100%;
    padding-right: 8rem;
  }

  .buttons-bottom > hr {
    padding-bottom: 1rem;
  }

  .meeting-extra {
    margin-right: 1rem;
  }

  .col-info {
    margin-top: -3rem;
  }

  .btn-rounded {
    padding: 15px 30px;
    margin: 0 .5rem;
  }

  @media screen and (max-width: 992px) {
    .meeting-extra {
      margin-right: 0;
    }

    .meeting-item-col {
      padding-right: 0;
      margin-bottom: 3rem;
    }

    .col-info {
      margin-top: 0;
    }

    #info-card {
      margin-left: 15px;
      margin-bottom: 3rem;
    }

    .buttons-bottom {
      position: static;
      padding-right: 0;
    }
  }

  @media screen and (max-width: 675px) {
    #meeting-title {
      font-size: 1.5rem;
    }
  }

  @media screen and (max-width: 550px) {
    .card-body-modified {
      padding: 6.5rem 1rem 0 1rem;
    }

    #item-title {
      font-size: 1rem;
    }

    #item-description {
      display: none;
    }

    .buttons-bottom {
      bottom: 10%;
      padding-right: 2rem;
    }

    .buttons-bottom > button {
      margin-bottom: 2rem;
    }
  }

  #meeting-items-list{
    overflow-y: scroll;
  }
</style>



// WEBPACK FOOTER //
// src/components/MeetingView.vue